import Modal from "@/components/common/Modal";
import { useTranslation } from "react-i18next";

type Props = {
  onClose: () => void;
};

const GrandPromoThailand = ({ onClose }: Props) => {
  const { t } = useTranslation();

  return (
    <Modal title={"Grand Promo Thailand 2025"} onClose={onClose}>
      <div className="w-full flex flex-col items-center px-4 pb-5 gap-3">
        <img
          src="/images/promo/yacht.png"
          alt=""
          className="shrink-0 w-full h-[12.625rem] object-cover rounded-xl"
        />

        <div className="w-full flex flex-col py-0.5 rounded-xl bg-plain-background">
          <div className="w-full flex flex-col gap-0.5 px-4 py-3">
            <p className="text-[0.9375rem] leading-5 tracking-tighter text-subtitle-text">
              {t("main-page.promo_thailand.modal.location")}
            </p>
            <p className="text-[1.0625rem] leading-5.5 tracking-tighter text-text">
              {t("main-page.promo_thailand.modal.thailand")}
            </p>
          </div>

          <div className="w-full px-4">
            <div className="w-full h-px bg-divider"></div>
          </div>

          <div className="w-full flex flex-col gap-0.5 px-4 py-3">
            <p className="text-[0.9375rem] leading-5 tracking-tighter text-subtitle-text">
              {t("main-page.promo_thailand.modal.dates")}
            </p>
            <p className="text-[1.0625rem] leading-5.5 tracking-tighter text-text">
              {t("main-page.promo_thailand.modal.december")}{" "}
              <span className="text-hint">
                ({t("main-page.promo_thailand.modal.nights")})
              </span>
            </p>
          </div>

          <div className="w-full px-4">
            <div className="w-full h-px bg-divider"></div>
          </div>

          <div className="w-full flex flex-col gap-0.5 px-4 py-3">
            <p className="text-[0.9375rem] leading-5 tracking-tighter text-subtitle-text">
              {t("main-page.promo_thailand.modal.period")}
            </p>
            <p className="text-[1.0625rem] leading-5.5 tracking-tighter text-text">
              {t("main-page.promo_thailand.modal.dates_period")}
            </p>
          </div>

          <div className="w-full px-4">
            <div className="w-full h-px bg-divider"></div>
          </div>

          <div className="w-full flex flex-col gap-0.5 px-4 py-3">
            <p className="text-[0.9375rem] leading-5 tracking-tighter text-subtitle-text">
              {t("main-page.promo_thailand.modal.req_opt_a")}
            </p>
            <p className="text-[1.0625rem] leading-5.5 tracking-tighter text-text">
              {t("main-page.promo_thailand.modal.req_opt_a_value")}
            </p>
          </div>

          <div className="w-full px-4">
            <div className="w-full h-px bg-divider"></div>
          </div>

          <div className="w-full flex flex-col gap-0.5 px-4 py-3">
            <p className="text-[0.9375rem] leading-5 tracking-tighter text-subtitle-text">
              {t("main-page.promo_thailand.modal.req_opt_b")}
            </p>
            <p className="text-[1.0625rem] leading-5.5 tracking-tighter text-text whitespace-pre-line">
              {t("main-page.promo_thailand.modal.req_opt_b_value")}
            </p>
          </div>

          <div className="w-full px-4">
            <div className="w-full h-px bg-divider"></div>
          </div>

          <div className="w-full flex flex-col gap-0.5 px-4 py-3">
            <p className="text-[0.9375rem] leading-5 tracking-tighter text-subtitle-text">
              {t("main-page.promo_thailand.modal.includes")}
            </p>
            <p className="text-[1.0625rem] leading-5.5 tracking-tighter text-text whitespace-pre-line">
              {t("main-page.promo_thailand.modal.includes_value")}
            </p>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default GrandPromoThailand;
